export default __webpack_public_path__ + "static/media/upgrade.bc901d23.svg";